import React, { useState, useEffect } from 'react';
import image4 from '../assets/images/image4.png';
import { MyButton } from './ui/MyButton.js';
import BenefitsSection from './ui/BenefitsSection.js';
import { benefitsOfMobileApp, mobileAppOptions } from '../constant.js';
import { useNavigate } from "react-router-dom";
import ScrollAnimation from 'react-animate-on-scroll';

const ServicesMobileApp = () => {
    const navigate = useNavigate();
    const [activeOption, setActiveOption] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className='animated_card'>
            <div className={`${isMobile ? "sizedbox" : ""} row g-2 gap-2 justify-content-end mt-5`}>
                <ScrollAnimation animateIn='fadeInLeft' className='col-12 col-md-6'
                    animateOut='fadeOutLeft' initiallyVisible="true">
                    <div style={{ paddingLeft: !isMobile ? "5%" : "0" }}>
                        
<h2 style={{ color: "#000000" }}>
    Mobile Application
    <br />
    <span
        style={{
            background: "var(--primary-gradient-100)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
        }}
    >
        for Koha LMS
    </span>
</h2>

                         
                        <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px", marginBottom: "30px", width: "80%" }}>
                            <strong>Extend Your Koha Offering with Mobile Access</strong><br /><br />

LibCloud's mobile application for Koha LMS brings library discovery and essential library services to users' smartphones. Available for Android and iOS, the app provides a convenient way to browse the library catalogue, explore book details with images, and check item availability while on the go.<br /><br />

Designed to complement your hosted Koha platform, the mobile application helps you offer a more accessible and engaging digital experience to your clients without developing a mobile solution from scratch.<br /><br />

<strong>Expand your library technology portfolio with a mobile solution backed by LibCloud.</strong>
                        </p>
                        <div className='mt-auto'>
                            <MyButton btntext="Contact Us" onClick={() => { navigate("/contact") }} />
                        </div>
                    </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn='fadeInRight' className='col-12 col-md-5'
                    animateOut='fadeOutRight' initiallyVisible="true">
                    <div>
                        <img src={image4} alt='Mobile App' style={{ width: "100%", height: "auto", maxHeight: "500px", borderRadius: isMobile ? "20px" : "" }}></img>
                    </div>
                </ScrollAnimation>
            </div>
            {/* Features of Mobile Application - styled to match Koha Business Benefits */}
            <section className="mobile-app-features-section" style={{
                padding: "80px 5%",
                marginTop: "50px",
                background: "linear-gradient(180deg, #F5F8FF 0%, #FFFFFF 100%)"
            }}>
                <style>{`
                    @keyframes mobileFeatureFadeUp {
                        from { opacity: 0; transform: translateY(24px); }
                        to { opacity: 1; transform: translateY(0); }
                    }

                    .mobile-app-features-section .features-eyebrow {
                        font-size: 13px;
                        font-weight: 700;
                        letter-spacing: 1.5px;
                        color: #3568C0;
                        margin-bottom: 16px;
                    }

                    .mobile-app-features-section .features-heading {
                        color: var(--text-color);
                        font-weight: 700;
                        font-size: clamp(28px, 3vw, 40px);
                        line-height: 1.3;
                        margin: 0;
                    }

                    .mobile-app-features-section .features-gradient {
                        background: var(--primary-gradient-100);
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    .mobile-app-features-section .features-grid {
                        display: grid;
                        grid-template-columns: repeat(4, minmax(0, 1fr));
                        gap: 22px;
                        margin-top: 40px;
                    }

                    .mobile-app-features-section .feature-card {
                        min-width: 0;
                        min-height: 280px;
                        padding: 28px 24px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        background: #fff;
                        border: 1px solid #E5EAF5;
                        border-radius: 16px;
                        box-shadow: 0 5px 20px rgba(30, 60, 120, 0.06);
                        transition: transform .25s ease, box-shadow .25s ease;
                        animation: mobileFeatureFadeUp .7s ease both;
                    }

                    .mobile-app-features-section .feature-number {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 44px;
                        height: 44px;
                        flex-shrink: 0;
                        margin-bottom: 20px;
                        border-radius: 12px;
                        background: var(--primary-gradient-10);
                        color: #3568C0;
                        font-size: 16px;
                        font-weight: 700;
                    }

                    .mobile-app-features-section .feature-title {
                        color: var(--text-color);
                        font-size: 19px;
                        font-weight: 700;
                        line-height: 1.4;
                        margin: 0 0 12px;
                        overflow-wrap: anywhere;
                    }

                    .mobile-app-features-section .feature-description {
                        color: var(--text-color);
                        font-size: 15px;
                        line-height: 1.7;
                        margin: 0;
                        text-align: left;
                        overflow-wrap: anywhere;
                    }

                    .mobile-app-features-section .feature-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 12px 28px rgba(30, 60, 120, .12);
                    }

                    @media (max-width: 1199px) {
                        .mobile-app-features-section .features-grid {
                            grid-template-columns: repeat(2, minmax(0, 1fr));
                        }
                    }

                    @media (max-width: 575px) {
                        .mobile-app-features-section {
                            padding: 55px 5% !important;
                        }

                        .mobile-app-features-section .features-grid {
                            grid-template-columns: minmax(0, 1fr);
                            gap: 18px;
                            margin-top: 28px;
                        }

                        .mobile-app-features-section .feature-card {
                            min-height: auto;
                            padding: 24px;
                        }
                    }

                    @media (prefers-reduced-motion: reduce) {
                        .mobile-app-features-section .feature-card {
                            animation: none;
                            transition: none;
                        }
                    }
                `}</style>

                <div className="container">
                    <div style={{ marginBottom: "0" }}>
                        <p className="features-eyebrow">DESIGNED FOR MODERN LIBRARIES</p>
                        <h2 className="features-heading">
                            Features of <span className="features-gradient">Mobile Application</span>
                        </h2>
                    </div>

                    <div className="features-grid">
                        {benefitsOfMobileApp.map((item, index) => (
                            <article
                                className="feature-card"
                                key={item.title || index}
                                style={{ animationDelay: `${index * 0.12}s` }}
                            >
                                <h3 className="feature-title">{item.title}</h3>
                                <p className="feature-description">{item.desc}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
            <div className='mt-5 p-4 text-center' style={{ backgroundImage: "linear-gradient(0, white  0 50%, #EBF1FD 50% 100%)" }}>
                <h2 style={{ color: "var(--text-color)" }}>
                    Options for&nbsp;
                    <span
                        style={{
                            background: "var(--primary-gradient-100)",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        }}>Mobile Application</span>
                </h2>
                <div className='mt-4 d-flex flex-wrap gap-4 justify-content-center' style={{ margin: "50px 0", }}>
                    {
                        mobileAppOptions.map((item, index) => (
                            <div className={`options-card ${activeOption === index ? "active" : ""}`}
                                onMouseEnter={() => setActiveOption(index)}
                                style={{ background: activeOption === index ? "var(--primary-gradient-100)" : "transparent", borderRadius: "20px", padding: "2px" }}>
                                <div style={{ backgroundColor: "#F7F6FF", borderRadius: "18px", padding: "30px", boxShadow: "0px 4px 5px 0px #00000033", height: "100%" }}>
                                    {
                                        activeOption === index ? <p
                                            style={
                                                {
                                                    fontSize: "30px", fontWeight: "400", lineHeight: "42px",
                                                    background: "var(--primary-gradient-100)",
                                                    backgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                }
                                            }>{item.title}</p>
                                            : <p
                                                style={
                                                    {
                                                        fontSize: "30px", fontWeight: "400", lineHeight: "42px", color: "#848489"
                                                    }
                                                }>{item.title}</p>
                                    }

                                    <img style={{ maxWidth: "300px" }} src={item.image} alt={item.title}></img>
                                    <div className='mt-4'>
                                        {
                                            item.steps.map((step, index) => (
                                                <div className='d-flex gap-2 mt-2'>
                                                    <div className='rounded-circle text-center align-items-center align-content-center' style={{ width: "30px", height: "30px", background: "var(--primary-gradient-10)" }}>
                                                        <p className='m-auto' style={{ fontSize: "16px", fontWeight: "400", lineHeight: "18px" }}>{index + 1}</p></div>
                                                    <h3 style={{ fontSize: "20px", fontWeight: "400", lineHeight: "30px" }}>{step}</h3>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default ServicesMobileApp;
